
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"3.509","cy":"7.5","r":".948"}}),_c('path',{attrs:{"fill":"none","stroke":"#000","stroke-miterlimit":"10","stroke-width":"1.063","d":"M5.938 5.936l6.622.02L14.138 7.5l-1.552 1.544h-.777l-.787-.788-.788.788H8.995l-.787-.788-.787.788-1.477.009a2.779 2.779 0 11-.006-3.117z"}})])
          )
        }
      }
    